import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initSentry, SentryErrorBoundary } from "@/lib/sentry";

// Initialize error tracking (no-op if REACT_APP_SENTRY_DSN is not set)
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Simple fallback shown to users if a rendering error slips through
const ErrorFallback = () => (
  <div style={{
    minHeight: '100vh',
    background: '#000',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    fontFamily: 'Inter, sans-serif',
    textAlign: 'center',
  }}>
    <div>
      <p style={{ color: '#FF3D2E', fontSize: 11, letterSpacing: '0.4em', marginBottom: 24 }}>
        SMG MEDIA GROUP
      </p>
      <h1 style={{ fontSize: 32, marginBottom: 12 }}>Something interrupted the reel.</h1>
      <p style={{ opacity: 0.7, marginBottom: 32 }}>
        We&apos;ve been notified. Refresh to try again — or reach us at hello@smgmediagroup.com.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: 'transparent',
          border: '1px solid #fff',
          color: '#fff',
          padding: '14px 32px',
          fontSize: 12,
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          cursor: 'pointer',
        }}
      >
        Refresh
      </button>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
